"use client";
import React from "react";

import Example from "../Example.jsx";
import Case from "../Case.jsx";
import { NumSlider } from "src/components/ui/NumSlider";
import Text from "../../../src/components/ui/Text";

const ValueOf1PercExample = () => {
  return (
    <Example>
      <Case rate={3}>
        {({ rate, doublingPeriod, onRateChange }) => (
          <Case rate={2}>
            {({
              rate: realRate,
              doublingPeriod: realDoublingPeriod,
              onRateChange: onRealRateChange,
            }) => (
              <Text>
                Lets say your investment is giving you{" "}
                <NumSlider
                  num={rate}
                  percent
                  min={1}
                  max={10}
                  onChange={(r) => {
                    onRateChange(r);
                    onRealRateChange(r - (rate - realRate));
                  }}
                />{" "}
                interest rate and the management fees is{" "}
                <NumSlider
                  percent
                  num={rate - realRate}
                  min={1}
                  max={3}
                  onChange={(x) => onRealRateChange(rate - x)}
                />
                . That <b>{rate - realRate}%</b> is increasing your investments
                doubling period by approximately{" "}
                <b>
                  {Math.round(
                    (realDoublingPeriod || 0) - (doublingPeriod || 0),
                  )}
                </b>{" "}
                years.
              </Text>
            )}
          </Case>
        )}
      </Case>
    </Example>
  );
};

export default ValueOf1PercExample;
